import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="animate-pulse font-heading text-lg text-slate-400">Loading…</div>
    </div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "OWNER" && user.role !== "ADMIN") return <Navigate to="/app" replace />;
  return children;
}
